<template>
  <v-app class="d-flex">
    <div style="display:flex; overflow:hidden;">
      <!-- <transition name="slide"> -->
        <SideNav v-if="$store.state.sideNav && $store.getters.isAuth" style="padding-top:60px;"/>
      <!-- </transition> -->

      <!-- <transition name="slide2"> -->
      <v-content
        id="content"
        :class="{'nav-open' : $store.state.sideNav  }"
        class="d-flex flex-column"
      >
        <Header id="nav" :class="{'nav-open' : $store.state.sideNav}"/>
        <router-view style="margin-top:60px;"></router-view>
      </v-content>
      <!-- </transition> -->
    </div>
  </v-app>
</template>

<script>
import Header from "@/components/Header.vue";
import SideNav from "@/components/SideNav.vue";
export default {
  name: "App",
  created() {
    this.$store.dispatch("getPrefectures");
    
  },
  components: {
    Header,
    SideNav
  }
};
</script>

<style lang="scss" scoped>
#content {
  height: 100vh;
  overflow: auto;
  width: 100vw;
  scroll-behavior: auto;
  background-color: rgb(242, 242, 242);

  &.nav-open {
    width: calc(100vw - 200px);
  }
}

#nav{
  position: fixed;
  right: 0;
  left: 0;
  height:100px;
  z-index: 100;
}



// .slide-leave-active,
// .slide-enter-active {
//   transition: .11s;
// }
// .slide-enter {
//   transform: translate(100%, 0);
// }
// .slide-leave-to {
//   transform: translate(-100%, 0);
// }

// .slide2-leave-active,
// .slide2-enter-active {
//   transition: 0s;
// }
// .slide2-enter {
//   transform: translate(100%, 0).slide-leave-active,
// .slide-enter-active {
//   transition: .11s;
// }
// .slide-enter {
//   transform: translate(100%, 0);
// }
// .slide-leave-to {
//   transform: translate(-100%, 0);
// }

// .slide2-leave-active,
// .slide2-enter-active {
//   transition: 0s;
// }
// .slide2-enter {
//   transform: translate(100%, 0);
// }
// .slide2-leave-to {
//   transform: translate(-100%, 0);
// }

//   transform: translate(-100%, 0);
// }

// .enter { transform: translateX(100%) }
// .enter-to { transform: translateX(0) }
// .slide-enter-active { position: absolute }

// .leave { transform: translateX(0) }
// .leave-to { transform: translateX(-100%) }

// .slide-enter-active,
// .slide-leave-active { transition: all 750ms ease-in-out }
</style>
